import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import axios from "axios";
import { Lock, User, ArrowRight, Shield } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent } from "@/components/ui/card";
import { toast } from "sonner";
import ThemeToggle from "@/components/ThemeToggle";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminLogin = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API}/auth/login`, { username, password });
      localStorage.setItem("token", res.data.token); localStorage.setItem("username", res.data.username);
      toast.success("Login successful!"); navigate("/admin/dashboard");
    } catch (err) { toast.error(err.response?.data?.detail || "Authentication failed"); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-950 flex flex-col">
      <header className="bg-white dark:bg-slate-900 border-b border-slate-200 dark:border-slate-800 shadow-sm">
        <div className="max-w-7xl mx-auto px-6 py-3 flex justify-between items-center">
          <Link to="/" className="flex items-center w-fit"><img src="/logo-v2.png" alt="SHIPP SMART" className="h-14 w-auto rounded-md" /></Link>
          <ThemeToggle />
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-6 py-12">
        <motion.div initial={{ opacity: 0, y: 15 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-md">
          <Card className="bg-white dark:bg-slate-900 border-slate-200 dark:border-slate-800 rounded-xl shadow-lg shadow-slate-900/5 dark:shadow-black/20">
            <CardContent className="p-8">
              <div className="text-center mb-8">
                <div className="w-14 h-14 rounded-xl bg-slate-900 dark:bg-slate-800 flex items-center justify-center mx-auto mb-4"><Shield className="w-7 h-7 text-orange-500" /></div>
                <h1 className="font-outfit font-bold text-2xl text-slate-900 dark:text-white" data-testid="auth-title">Admin Login</h1>
                <p className="text-slate-500 dark:text-slate-400 text-sm mt-2">Access the shipment management portal</p>
              </div>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div className="space-y-2"><Label htmlFor="username" className="text-xs font-bold tracking-[0.2em] uppercase text-slate-500 dark:text-slate-400">Username</Label><div className="relative"><User className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" /><Input id="username" type="text" value={username} onChange={(e) => setUsername(e.target.value)} placeholder="Enter username" className="h-11 pl-10 rounded-lg" required data-testid="username-input" /></div></div>
                <div className="space-y-2"><Label htmlFor="password" className="text-xs font-bold tracking-[0.2em] uppercase text-slate-500 dark:text-slate-400">Password</Label><div className="relative"><Lock className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" /><Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Enter password" className="h-11 pl-10 rounded-lg" required data-testid="password-input" /></div></div>
                <Button type="submit" disabled={loading} className="w-full h-11 bg-orange-600 hover:bg-orange-500 text-white font-medium rounded-lg transition-colors" data-testid="submit-btn">{loading ? "Signing in..." : "Sign In"}<ArrowRight className="w-4 h-4 ml-2" /></Button>
              </form>
            </CardContent>
          </Card>
        </motion.div>
      </main>

      <footer className="border-t border-slate-200 dark:border-slate-800 py-6 bg-white dark:bg-slate-900">
        <div className="max-w-7xl mx-auto px-6 text-center"><p className="text-slate-400 text-sm">&copy; {new Date().getFullYear()} SHIPP SMART. Admin Portal.</p></div>
      </footer>
    </div>
  );
};

export default AdminLogin;
